import { User, UserResponse, UsersEntity } from '@/store/models';
import { Vue, Prop } from 'vue-property-decorator';

export class Helpers {
  public static megabyte: number = 1048576;
  public static emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  public static urlRegex = /(https?:\/\/(?:www\.|(?!www))[[a-zA-Z0-9-]+\.[^\s]{2,}|www\.[a-zA-Z0-9-]+\.[^\s]{2,})/;
  public static projectLabel = 'Network';
  public static projectNetworkLabel = 'Supply Network';
  public static projectsLabel = 'Networks';
  public static projectNetworksLabel = 'Supply networks';

  public static australian_states = [
    "New South Wales",
    "Victoria",
    "Queensland",
    "South Australia",
    "Western Australia",
    "Tasmania",
    "Northern Territory",
    "Australian Capital Territory",
  ]
  // Custom Style from https://snazzymaps.com/explore?color=gray
  public static MapFilterStyle = [
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#d3d3d3',
        },
      ],
    },
    {
      featureType: 'transit',
      stylers: [
        {
          color: '#808080',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#b3b3b3',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#ffffff',
        },
        {
          weight: 1.8,
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#d7d7d7',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#ebebeb',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [
        {
          color: '#a7a7a7',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#efefef',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#696969',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#737373',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#d6d6d6',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {},
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#dadada',
        },
      ],
    },
  ];

  public static fieldOptions = [
    {
      text: 'Text',
      icon: 'fas fa-font',
      value: {
        type: 'field',
        priority: null,
        text: 'Text',
        entity: {
          field_type: 'input',
          required: true,
          label: '',
          name: 'section_field_' + Helpers.RandomStringGenerator(4),
          show: true,
          edit: true,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: '',
        },
      },
    },
    {
      text: 'Paragraph',
      icon: 'fas fa-paragraph',
      value: {
        type: 'field',
        priority: null,
        text: 'Paragraph',
        entity: {
          field_type: 'textarea',
          required: true,
          label: '',
          name: 'section_field_' + Helpers.RandomStringGenerator(4),
          show: true,
          edit: true,
          min: 0,
          max: 500,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: '',
        },
      },
    },
    {
      text: 'Checkbox',
      icon: 'crop_square',
      value: {
        type: 'field',
        priority: null,
        text: 'Checkbox',
        entity: {
          field_type: 'checkbox',
          required: false,
          label: '',
          name: 'section_field_' + Helpers.RandomStringGenerator(4),
          show: true,
          edit: true,
          default: '',
          tooltip: '',
          help_text: '',
          single: 'true',
        },
      },
    },
    {
      text: 'Checkboxes',
      icon: 'fas fa-th-large',
      value: {
        type: 'field',
        text: 'Checkboxes',
        priority: null,
        entity: {
          field_type: 'checkbox',
          required: false,
          label: '',
          name: 'section_field_' + Helpers.RandomStringGenerator(4),
          default: '',
          tooltip: '',
          help_text: '',
          single: 'false',
          choices: ['', ''],
        },
      },
    },
    {
      text: 'Dropdown',
      icon: 'fas fa-caret-down',
      value: {
        type: 'field',
        priority: null,
        text: 'Dropdown',
        entity: {
          field_type: 'select',
          required: true,
          label: '',
          name: 'section_field_' + Helpers.RandomStringGenerator(4),
          default: '',
          tooltip: '',
          help_text: '',
          single: 'false',
          choices: ['', ''],
          placeholder: '',
        },
      },
    },
    {
      text: 'Files',
      icon: 'fas fa-file-pdf',
      value: {
        type: 'field',
        priority: null,
        text: 'Files',
        entity: {
          field_type: 'file',
          required: true,
          label: '',
          name: 'section_field_' + Helpers.RandomStringGenerator(4),
          default: '',
          tooltip: '',
          help_text: '',
          single: 'false',
          choices: [],
        },
      },
    },
    {
      text: 'Multiple Choice',
      icon: 'adjust',
      value: {
        type: 'field',
        priority: null,
        text: 'Multiple Choice',
        entity: {
          field_type: 'radio',
          required: true,
          label: '',
          name: 'section_field_' + Helpers.RandomStringGenerator(4),
          default: '',
          tooltip: '',
          help_text: '',
          single: 'false',
          choices: ['', ''],
        },
      },
    },
  ];

  public static surveyQuestionChoices = [
    {
      text: 'Text',
      icon: 'fas fa-font',
      value: {
        type: 'field',
        priority: null,
        text: 'Text',
        entity: {
          field_type: 'input',
          required: true,
          label: '',
          name: 'section_field_',
          show: true,
          edit: true,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: '',
        },
      },
    },
    {
      text: 'Checkbox',
      icon: 'crop_square',
      value: {
        type: 'field',
        priority: null,
        text: 'Checkbox',
        entity: {
          field_type: 'checkbox',
          required: false,
          label: '',
          name: 'section_field_',
          show: true,
          edit: true,
          default: '',
          tooltip: '',
          help_text: '',
          single: 'true',
        },
      },
    },
    {
      text: 'Checkboxes',
      icon: 'fas fa-th-large',
      value: {
        type: 'field',
        text: 'Checkboxes',
        priority: null,
        entity: {
          field_type: 'checkbox',
          required: false,
          label: '',
          name: 'section_field_',
          default: '',
          tooltip: '',
          help_text: '',
          single: 'false',
          choices: ['', ''],
        },
      },
    },
    {
      text: 'Dropdown',
      icon: 'fas fa-caret-down',
      value: {
        type: 'field',
        priority: null,
        text: 'Dropdown',
        entity: {
          field_type: 'select',
          required: true,
          label: '',
          name: 'section_field_',
          default: '',
          tooltip: '',
          help_text: '',
          single: 'false',
          choices: ['', ''],
          placeholder: '',
        },
      },
    },
    {
      text: 'Multiple Choice',
      icon: 'adjust',
      value: {
        type: 'field',
        priority: null,
        text: 'Multiple Choice',
        entity: {
          field_type: 'radio',
          required: true,
          label: '',
          name: 'section_field_',
          default: '',
          tooltip: '',
          help_text: '',
          single: 'false',
          choices: ['', ''],
        },
      },
    },
  ]

  public static staticFieldOptions = [
    {
      name: '1',
      text: 'Heading 1',
      icon: 'mdi-format-header-1',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'input',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: 'Add text',
          new: true,
          order: null,
          style: 'heading1',
          content: '',
        },
      },
    },
    {
      name: '2',
      text: 'Heading 2',
      icon: 'mdi-format-header-2',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'input',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: 'Add text',
          new: true,
          order: null,
          style: 'heading2',
          content: '',
        },
      },
    },
    {
      name: '3',
      text: 'Heading 3',
      icon: 'mdi-format-header-3',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'input',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: 'Add text',
          new: true,
          order: null,
          style: 'heading3',
          content: '',
        },
      },
    },
    {
      name: '4',
      text: 'Heading 4',
      icon: 'mdi-format-header-4',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'input',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: 'Add text',
          new: true,
          order: null,
          style: 'heading4',
          content: '',
        },
      },
    },
    {
      name: '',
      text: 'Paragraph',
      icon: 'fas fa-paragraph',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'textarea',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: 'Add text',
          new: true,
          order: null,
          content: '',
        },
      },
    },
    {
      name: '',
      text: 'Image(s)',
      icon: 'image',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'file',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          new: true,
          order: null,
          content: '',
          accept: 'images',
          files: [],
          single: 'true',
        },
      },
    },
    {
      name: '',
      text: 'Document(s)',
      icon: 'fas fa-file-pdf',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'file',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          new: true,
          order: null,
          content: '',
          accept: 'documents',
          files: [],
          single: 'false',
        },
      },
    },
    {
      name: '',
      text: 'List',
      icon: 'fas fa-list-ul',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'radio',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          new: true,
          order: null,
          content: '',
          choices: ['', ''],
        },
      },
    },
  ];

  public static surveyStaticFieldOptions = [
    {
      name: '1',
      text: 'Heading 1',
      icon: 'mdi-format-header-1',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'input',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: 'Add text',
          new: true,
          order: null,
          style: 'heading1',
          content: '',
        },
      },
    },
    {
      name: '2',
      text: 'Heading 2',
      icon: 'mdi-format-header-2',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'input',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: 'Add text',
          new: true,
          order: null,
          style: 'heading2',
          content: '',
        },
      },
    },
    {
      name: '3',
      text: 'Heading 3',
      icon: 'mdi-format-header-3',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'input',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: 'Add text',
          new: true,
          order: null,
          style: 'heading3',
          content: '',
        },
      },
    },
    {
      name: '4',
      text: 'Heading 4',
      icon: 'mdi-format-header-4',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'input',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: 'Add text',
          new: true,
          order: null,
          style: 'heading4',
          content: '',
        },
      },
    },
    {
      name: '',
      text: 'Paragraph',
      icon: 'fas fa-paragraph',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'textarea',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          placeholder: 'Add text',
          new: true,
          order: null,
          content: '',
        },
      },
    },
    {
      name: '',
      text: 'List',
      icon: 'fas fa-list-ul',
      value: {
        type: 'field',
        priority: null,
        entity: {
          field_type: 'radio',
          required: false,
          label: 'Enter label',
          name: 'field_',
          show: true,
          edit: false,
          default: '',
          tooltip: '',
          help_text: '',
          new: true,
          order: null,
          content: '',
          choices: ['', ''],
        },
      },
    },
  ];

  public static oneMegabyte() {
    return this.megabyte;
  }

  public static RandomStringGenerator(len: number, charSet: string | null = null) {
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for (let i = 0; i < len; i++) {
      const randomPoz = Math.floor(Math.random() * charSet.length);
      randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return randomString;
  }

  public static distinctPriorities(form: any) {
    return form.elements
      .map((el: any) => {
        return Number(el.priority);
      })
      .filter((item: any, i: number, ar: any[]) => {
        return ar.indexOf(item) === i;
      });
  }

  public static BuildFieldsArray(form: any, arr: any[] = []) {
    if (form && form.elements) {
      const priorities = Helpers.distinctPriorities(form);
      // ECX-1260 - updated sort function as it was not returning
      // correct sort order previously and caused the bug with ECX-1260 to happen
      priorities.sort((a: any, b: any) => {
        return a > b ? 1 : -1;
      });

      if (priorities && priorities.length > 0) {
        for (const item of priorities) {
          //  Get items having same priority
          arr.push(
            form.elements.filter((el: any) => {
              return Number(el.priority) === item;
            }),
          );
        }
      }
    }

    arr.forEach((el: any) => {
      el.sort((a: any, b: any) => {
        if (a.entity && b.entity) {
          return Number(a.entity.order) > Number(b.entity.order) ? 1 : -1;
        }
      });
    });
    return arr;
  }

  public static GenerateSurveyFirstChildForm(priority?: number) {
    // ECX-973, adding new as true to identify that it is a new element added to the ME and add child_id as null
    return new Object({
      priority: priority || 0,
      subtype: 'survey',
      type: 'form',
      tempid: Helpers.RandomStringGenerator(4),
      entity: {
        title: 'Question group title',
        description: '',
        elements: [
          {
            type: 'form',
            priority: 0,
            subtype: 'survey_subform',
            entity: {
              title: 'Question sub group title',
              description: '',
              elements: [],
              destroyedFields: []
            }
          }
        ]
      }
    });
  }

  public static GenerateStaticForm(priority?: number) {
    // ECX-973, adding new as true to identify that it is a new element added to the ME and add child_id as null
    return new Object({
      new: true,
      child_id: null,
      type: 'form',
      subtype: 'static',
      priority: priority || 0,
      entity: { title: '', service: 'MR', elements: [] },
      fieldsArray: [],
      destroyedFields: [],
    });
  }

  public static GenerateSurveyStaticForm(priority?: number) {
    // ECX-973, adding new as true to identify that it is a new element added to the ME and add child_id as null
    return new Object({
      new: true,
      child_id: null,
      type: 'form',
      subtype: 'static',
      priority: priority || 0,
      entity: { title: '', service: 'EconomX', elements: [] },
      fieldsArray: [],
      destroyedFields: [],
    });
  }

  public static GenerateSectionForm() {
    // ECX-973, adding new as true to identify that it is a new element added to the ME and add child_id as null
    return new Object({
      new: true,
      child_id: null,
      type: 'form',
      subtype: 'section',
      entity: { title: 'Additional Questions', service: 'MR', elements: [] },
      destroyedFields: [],
    });
  }

  public static PreparePackageForView(market_request: any) {
    if (market_request && market_request.location_attributes) {
      market_request.location_attributes.icon = 'scripts/img/yellow-dot.png';
    } else {
      market_request.location_attributes = { icon: 'scripts/img/yellow-dot.png' };
    }
    if (market_request && market_request.form && market_request.form.elements) {
      market_request.form.elements.sort((a: any, b: any) => {
        return a.priority > b.priority ? 1 : -1;
      });
      market_request.form.elements.forEach((elem: any) => {
        elem.entity.elements = elem.entity.elements.sort((a: any, b: any) => {
          return a.priority > b.priority ? 1 : -1;
        });
        if (elem.subtype === 'static') {
          elem['fieldsArray'] = Helpers.BuildFieldsArray(elem.entity);
        } else if (elem.subtype === 'category') {
          elem.entity.elements = elem.entity.elements.sort((a: any, b: any) => {
            return a.priority > b.priority ? 1 : -1;
          });
          elem.entity.elements.forEach((criteria: any) => {
            criteria.entity.ratings = criteria.entity.ratings.sort((a: any, b: any) => {
              return Number(a.value) > Number(b.value) ? 1 : -1;
            });
            criteria.entity.ratings.forEach((rating: any, i: number) => {
              rating.edit = false;
            })
          });
        }
        elem['destroyedFields'] = [];
      });
    }
    return market_request;
  }

  public static StructureMarketRequestResponse(mr: any, login: any) {
    const market_request = JSON.parse(JSON.stringify(mr));
    // Making a deep copy so that the stringified field data
    // for checkboxes doesn't show unchecked fields after hitting save
    const market_request_response = {
      id: market_request.market_request_response ? market_request.market_request_response.id : null,
      business_id: login.organization_id,
      project_id: market_request.project_id,
      market_request_id: market_request.id,
      service: 'EconomX',
      creator_id: login.id,
      respond: market_request.respond,
      location_attributes: market_request.market_request_response.location_attributes,
      contact_id: market_request.market_request_response.contact_id,
      contact_number: market_request.market_request_response.contact_number,
      form: market_request.form,
      supplier_categories: market_request.market_request_response.category_ids,
      destroyed_categories: market_request.destroyed_categories,
      package_type: market_request.package_type
    };

    if (market_request.form) {
      // Filter non static forms as we do not want to send static/information sections on the MR
      // to the backend when creating response/form-data-set
      market_request_response.form.elements = market_request.form.elements.filter((el: any) => {
        return el.subtype !== 'static';
      });
      // Fixes ECX-1188, static form being sent to the backend when there are more than 1 static form
      market_request_response.form.elements.forEach((el: any, i: number) => {
        if (el.subtype === 'section') {
          if (el.entity.elements.length > 0) {
            el.entity.elements.forEach((element: any) => {
              if (element.entity.data && element.entity.data instanceof Array) {
                element.entity.data = JSON.stringify(element.entity.data);
              }
            });
          }
        }
      });
    }

    return market_request_response;
  }

  public static CheckWeightingCount(form: any) {
    let count = 0;
    const max = 100;
    form.elements.forEach((elem: any) => {
      if (elem.entity && elem.entity.weighting && !elem.entity._destroy) {
        count = count + Number(elem.entity.weighting);
      }
    });
    return count === max;
  }

  public static ProfileUpdatePrompt() {
    const config = {
      title: 'Incomplete Business Profile',
      text:
        `We've made some changes to the details we ask you to ` +
        `provide on your business profile.\n\nWe need you to provide us ` +
        `a bit more information before you are able to register your interest and apply for work.\n\n`,
      showCancelButton: true,
      cancelButtonText: 'Skip',
      confirmButtonText: 'Update Profile',
    };
    return Vue.swal(config);
  }

  public static ObjectToFormData(input: any = {}, name: string = '', form: FormData = new FormData()) {
    for (const prop in input) {
      if (input.hasOwnProperty(prop)) {
        let key = prop;
        if (name !== null) {
          key = `${name}[${prop}]`;
        }

        if (input[prop] instanceof Array) {
          // Arrays of Objects behave differently to how normal arrays work, resulting
          // object needs to be added to formdata in single lump instead of piecemeal recursion
          if (prop === 'files') {
            for (const item of input[prop]) {
              form.append(`${key}[]`, item);
            }
          } else {
            for (const item of input[prop]) {
              if (item instanceof Object) {
                Helpers.ObjectToFormData(item, `${key}[]`, form);
              } else {
                form.append(`${key}[]`, item);
              }
            }
          }
        } else if (input[prop] instanceof FileList) {
          if (input[prop].length > 1) {
            for (const item of input[prop]) {
              form.append(`${key}[]`, item);
            }
          } else if (input[prop].length === 1) {
            form.append(`${key}`, input[prop][0]);
          }
        } else if (input[prop] instanceof File) {
          form.append(key, input[prop]);
        } else if (input[prop] instanceof Object) {
          Helpers.ObjectToFormData(input[prop], key, form);
        } else if (
          input[prop] !== null &&
          input[prop] !== 'null' &&
          input[prop] !== undefined &&
          input[prop] !== 'undefined'
        ) {
          form.append(key, input[prop]);
        }
      }
    }
    return form;
  }

  // https://medium.com/welldone-software/map-pins-using-svg-path-9fdfebb74501
  public static PinPathCubicBezier(width: number, height: number) {
    const deltaX = width * Math.sqrt(3);
    const deltaY = (height * 4) / 3;
    return `M 0,0 C ${-deltaX},${-deltaY}
        ${deltaX},${-deltaY} 0,0 z`;
  }

  public static validatePhoneNumber(value: string) {
    return (
      value &&
      value.length > 0 &&
      value.match(/^[0-9()+\s]+$/) !== null &&
      (value.match(/\d/g) || []).length >= 10 &&
      (value.match(/\d/g) || []).length <= 15 &&
      (value.match(/\s/g) || []).length <= 4 &&
      (value.indexOf('+') === -1 || value.indexOf('+') === 0) &&
      (value.match(/\+/g) || []).length <= 1 &&
      (value.match(/\(/g) || []).length <= 1 &&
      (value.match(/\)/g) || []).length <= 1 &&
      (value.indexOf('(') === -1 ||
        value.indexOf(')') === -1 ||
        (value.indexOf('(') < value.indexOf(')') && value.indexOf(')') - value.indexOf('(') > 1)) &&
      (value.match(/\(/g) || []).length === (value.match(/\)/g) || []).length
    );
  }

  public static linkify(inputText: string) {
    // URLs starting with http://, https://, or ftp://
    const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    let replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

    // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    const replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

    // Change email addresses to mailto:: links.
    const replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
    return replacedText;
  }

  public static removeJsdWidget() {
    const script = document.getElementById('jsd-widget');
    if (script) {
      document.body.removeChild(script);
    }
  }
}
